<template>
  <vx-card no-shadow>
    <div id="editMailConfigLoadingDiv" class="vs-con-loading__container" style='min-height: 300px;'>
        <vs-collapse type="border" accordion>
            <vs-collapse-item >
                <div slot="header">
                    <p style="font-size: 14px">Signup Mail</p>
                </div>
                <div class="ml-1" style='min-height: 400px;'>
                    <quill-editor v-model="content" :options="editorOption">
                        <div id="toolbar" slot="toolbar">
                            <button class="ql-bold">Bold</button>
                            <button class="ql-italic">Italic</button>

                            <select class="ql-size">
                                <option value="small"></option>
                                <option selected></option>
                                <option value="large"></option>
                                <option value="huge"></option>
                            </select>

                            <select class="ql-font">
                                <option selected="selected"></option>
                                <option value="serif"></option>
                                <option value="monospace"></option>
                            </select>
                        </div>
                    </quill-editor>

                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <div class="mt-8 flex flex-wrap items-center justify-end">
                                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="previewMail('signup_mail')">Preview</vs-button>
                                <vs-button class="ml-4 mt-2" @click="saveMail('signup_mail')">Save Changes</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-collapse-item>
        </vs-collapse>
    </div>
  </vx-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
    data() {
        return {
            editorOption: {
                modules: {
                    toolbar: '#toolbar'
                }
            },
            content: ``,
        }
    },
    components: {
        quillEditor,
    },
    methods: {
        previewMail(mailKey) {
            this.$store.dispatch("clubManagement/previewMail", { mail_key : "signup_mail"})
                .then(res => {
                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                    var myWindow = window.open("", "response", "resizable=yes");
                    myWindow.document.write(res.data);
                })
                .catch(err => {
                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                })
        },
        saveMail(mailKey) {
            this.$vs.loading({
                container: '#editMailConfigLoadingDiv',
                scale: 0.6
            })

            let data =  { 
                mail_key : "signup_mail",
                mail_content : {
                    body : this.content,
                    subject : "Hi there",
                }
            }
            this.$store.dispatch("clubManagement/updateMails", data)
                .then(res => {
                    this.$vs.notify({
                        title: "Success.",
                        text: "Setting updated successfully.",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "success"
                    });

                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                })
                .catch(err => {
                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                })
        },
        getMailData() {
            this.$vs.loading({
                container: '#editMailConfigLoadingDiv',
                scale: 0.6
            })

            this.$store.dispatch("clubManagement/getMailData", { mail_key : "signup_mail"})
                .then(res => {
                    if(res.data){
                        this.content = res.data.mail_content.body
                    }
                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#editMailConfigLoadingDiv > .con-vs-loading')
                })
        },
    },
    mounted() {
        this.getMailData()
    },
    created() {
        if(!moduleClubManagement.isRegistered) {
            this.$store.registerModule('clubManagement', moduleClubManagement)
            moduleClubManagement.isRegistered = true
        }
    },
}
</script>
